<template>
  <div>
    <nav-breadcrumb :menu="[{label: '保证金台账'}]"/>
    <div class="xzpadd10 bg-purple of">
      <data-table
        :table-data="listData"
        :columns="columns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
        :actions="actions"
      />
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "DepositBalanceList",
      data(){
        return {
          page: 1,
          pageSize: 20,
          listData: {},
          dealerOptions:[],
          applicationStatus:'Pending Approval',
          filters: {
            labelWidth: '150px',
            form: {
              d__dealerId:'',

            },
            columns: [
              {
                label: '渠道商',
                component: 'el-select',
                field: 'd__dealerId',

                options:this.dealerOptions,
              },
            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            }
          },
          actions: [
            /*{
              label: '缴纳',
              class: 'el-button--primary',
              clickHandler: ()=>{
                this.$router.push({
                  path: 'addDA'
                })
              }
            },
            {
              label: '退还',
              class: 'el-button--primary',
              clickHandler: ()=>{
                this.$router.push({
                  path: 'addDR'
                })
              }
            }*/
          ],
        }
      },
      computed:{
        columns: function(){
          return [
            {
              type: 'index'
            },

            {
              label: '渠道商',
              field: 'd__dealerName'
            },
            {
              label: '保证金总额',
              field: 'bal__depositAmount',
              component:(r,c,v)=> {
                v = formatMoney(v)
                let showDepositTxList = this.showDepositTxList
                return {
                  template: `<div class="Htitle-text color-deep-blue hand" @click="showDepositTxList('`+ r.d__dealerId +`','`+ r.d__dealerName +`','`+ r.bal__depositAmount +`')">${v}</div>`,
                  methods: {
                    showDepositTxList,
                  }
                }
              },
            },
            {
              label: '保证金比例',
              field: 'bal__depositRatio',
              formatter: function (r,c,v) {
                return v+'%'
              }
            },
            {
              label: '可贷总额',
              field: 'bal__creditAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '占用额度',
              field: 'bal__reservedAmount',
              component:(r,c,v)=> {
                v = formatMoney(v)
                let showFinancingWithDepositList = this.showFinancingWithDepositList
                return {
                  template: `<div class="Htitle-text color-deep-blue hand" @click="showFinancingWithDepositList('`+ r.d__dealerId +`','`+ r.d__dealerName +`','`+ r.bal__reservedAmount +`')">${v}</div>`,
                  methods: {
                    showFinancingWithDepositList,
                  }
                }
              },
            },
            {
              label: '可贷余额',
              field: 'bal__availableAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
          ]
        },
        filterParams: {
          get: function() {
            return {
              pageSize: this.pageSize,
              pageOffset: (this.page - 1) * this.pageSize,


            }
          },
          set:function (newVal) {

          }
        }
      },
      watch: {
        filterParams: function () {
          this.getData()
        },
      },
      mounted(){
        this.getData()
        this.getDealerList()
      },
      methods:{
        getData: function () {
          xhr.getDepositBalanceList(
            Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
            res => {
              try {
                this.listData = res.data
              } catch (e) {

              }
            })
        },
        getDealerList: function () {
          xhr.getDealerList(
            Object.assign({pageSize:0}, {}, {}),
            res=> {
              try {
                this.filters.columns[0].options = res.data.data.map(item=>{
                  return {
                    label: item.d__dealerName,
                    value:item.d__dealerId,
                  }
                })
              }catch(e){

              }
            })

        },
        showDepositTxList:function(dealerId,dealerName,totalAmount){
          this.$router.push({
            name: 'DepositTxListView',
            query: {
              'dealerId': dealerId,
              'dealerName': dealerName,
              'totalAmount':totalAmount,
            }
          })

        },
        showFinancingWithDepositList:function(dealerId,dealerName,totalAmount){
          this.$router.push({
            name: 'FinancingWithDepositListView',
            query: {
              'dealerId': dealerId,
              'dealerName': dealerName,
              'totalAmount':totalAmount,
            }
          })

        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/DepositBalanceList.vue